import { Component, Input } from '@angular/core';
import { Message, MessageType } from '../models/message-types.enum';

@Component({
    selector: 'message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
    @Input() message: Message = { title: '', text: '', type: MessageType.Info };

    private iconMap = {
        '-info': 'eva-3-icon-info-circle-filled',
        '-success': 'eva-3-icon-checkmark-circle-filled',
        '-success-outlined': 'eva-3-icon-checkmark-circle',
    };

    get messageStyle(): string {
        if (this.message.type === MessageType.Success) {
            return '-success';
        } else if (this.message.type === MessageType.SuccessOutline) {
            return '-success';
        }
        return '-info';
    }

    get messageIcon(): string {
        return this.iconMap[this.message.type] || this.iconMap['-info'];
    }
}
